import ShiftEnum from "./../../../shared/ShiftEnum.js";
import vSelect from 'vue-select';
import { ValidationMessage, FormLabel } from "../../../shared/components";
import HolePopup from "./holePopup.vue";
import HoleSideView from "../../projects/components/holeSideView.vue";
import { ManipulateElement } from "@/app/shared/ManipulateElement.js";

export default {
  props: {
    stabilisations: {
      type: Array,
      default: () => { }
    },
    drillingEntries: {
      type: Array,
      default: () => { }
    },
    stagingDailyReportId: {
      type: Number
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    projectZones: {
      type: Array,
      default: () => { }
    },
    reportHoles: {
      type: Array,
      default: () => { }
    },
    projectId: {
      type: Number
    },
    addHoleToReportHoles: {
      type: Function,
      default: null
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    FormLabel,
    HolePopup,
    HoleSideView
  },
  data() {
    return {
      innerId: 0,
      activeSideView: false,
      activeHolePrompt: false,
      activeNotesPrompt: false,
      innerEntries: [],
      selectedEntry: null,
      shifts: ShiftEnum.definition,
      holePopupSelectedShift: ShiftEnum.Day,
      shellsList: [
        "6",
        "10",
        "18",
        "36",
        "54",
        "72"
      ],
      newHole: {} // Object for the sideview's v-model (not used directly)
    }
  },
  mounted()
  {
    this.fillStabilisationData();
  },
  watch: {
    stabilisations() {
      this.fillStabilisationData();
    },
    projectId() {
      this.fillStabilisationData();
    }
  },
  computed: {
    localizedLabel() {
      return this.$i18n.locale.startsWith('fr') ? "nameFr" : "nameEn";
    },
    coreBarrels() {
      return this.$store.state.drilling.coreBarrels;
    }
  },
  methods: {
    createStabilisation() {
      this.innerId++;
      this.selectedEntry = {
        stagingDailyReportId: this.stagingDailyReportId,
        stagingDrillingEntryId: 0,
        holeNumber: '',
        shift: ShiftEnum.Day,
        coreBarrelId: null,
        shell: null,
        from: null,
        to: null,
        innerId: this.innerId
      };
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    editHole(item) {
      this.selectedEntry = item;
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    closeHolePrompt() {
      this.activeHolePrompt = false;
      this.selectedEntry = null;
    },
    submitHole(entry, selectedHole) {
      this.activeHolePrompt = false;
      const indexOfHole = this.reportHoles.findIndex(h => h.holeId === entry.holeId);
      if (indexOfHole === -1) this.addHoleToReportHoles(selectedHole);
      let latestTo = null;
      let latestIsEndOfHole = false;
      if (selectedHole) {
        // look for the later entry for the same hole
        const data = this.innerEntries.filter(e => e.holeId === entry.holeId && e.shift <= entry.shift);
        if (data.length > 0) {
          const highestData = data.sort((a, b) => { return (a.to > b.to) ? -1 : 1 });
          latestTo = parseFloat(highestData[0].to);
          latestIsEndOfHole = highestData[0].isEndOfHole;
        } else {
          latestIsEndOfHole = selectedHole.latestIsEndOfHole;
          latestTo = parseFloat(selectedHole.stabilisationLatestTo);
        }

        // find other entries on the same hole number that wasn't mapped to an existing hole and update them
        const entriesOnSameHoleNumber = this.innerEntries.filter(e => e.holeNumber === entry.holeNumber
          && e.innerId !== entry.innerId
          && e.holeId === 0);
        entriesOnSameHoleNumber.forEach(e => {
          e.holeNumber = selectedHole.code;
          e.holeId = selectedHole.holeId;
        });

        const existingEntry = this.innerEntries.find(e => e.innerId === entry.innerId);
        entry.holeNumber = selectedHole.code;
        if (!existingEntry) {
          if (latestTo !== 0) entry.from = latestTo;
          if (latestTo !== 0) entry.to = latestTo + 1;
          entry.stabilisationLatestTo = latestTo;
          entry.isEndOfHole = latestIsEndOfHole;
          this.innerEntries.push(entry);
        }
        else {
          const index = this.innerEntries.indexOf(existingEntry);
          Object.assign(this.innerEntries[index], entry);
        }
        this.updateHoleLatestValues();
      }
    },
    updateHoleLatestValues() {
      this.innerEntries.forEach(element => {
        const selectedHole = this.reportHoles.find(h => h.code === element.holeNumber);
        if (selectedHole) {
          // look for the later entry for the same hole
          const stabilisationData = this.innerEntries.filter(e => e.holeNumber === element.holeNumber && e.shift <= element.shift && e.from < element.from);
          if (stabilisationData.length > 0) {
            const highestData = stabilisationData.sort((a, b) => { return (a.to > b.to) ? -1 : 1 });
            element.stabilisationLatestTo = highestData[0].to;
          } else {
            element.stabilisationLatestTo = selectedHole.stabilisationLatestTo;
          }
        }
      });
    },
    isShiftMissing(entry) {
      // shift 0 (Day) is falsy, so a truthiness test would report it as missing
      return !entry || entry.shift === null || entry.shift === undefined;
    },
    getHoleDescription(entry) {
      if (entry) {
        // shift can be null on imported entries; getNameFor would render the raw i18n key
        return entry.holeNumber + " - " + (this.isShiftMissing(entry) ? '' : ShiftEnum.getNameFor(entry.shift));
      }
      return '';
    },
    deleteHole(hole) {
      const index = this.innerEntries.findIndex(_ => _.innerId === hole.innerId);
      if (index === -1) return;
      this.innerEntries.splice(index, 1);
    },

    fillStabilisationData() {
      this.innerEntries = [];
      this.stabilisations.forEach((entry, idx) => {
        const element = Object.assign(entry, {}); // Cloning the object (because everything in JS is referenced)
        const entryHole = this.reportHoles.find(h => h.code === entry.holeNumber);
        element.holeId = entryHole === undefined ? 0 : entryHole.holeId;
        element.innerId = idx;
        this.innerEntries.push(element);
      });

      this.innerId = this.innerEntries.length;
      this.updateHoleLatestValues();
    },
    isFirstHoleOccurence(indextr, data, holeId) {
      return indextr === data.map(x => x.holeId).indexOf(holeId);
    },
    validateFromWithTo(entry) {
      if (this.readOnly) return true;
      if (!entry.from || !entry.to) return true;
      return entry.to && parseFloat(entry.from) < parseFloat(entry.to);
    },
    validateFromWithLatestEntry(entry) {
      if (this.readOnly) return true;
      if (!entry.from || !entry.stabilisationLatestTo) return true;
      return entry.stabilisationLatestTo &&
        parseFloat(entry.stabilisationLatestTo) !== 0 &&
        parseFloat(entry.from) >= parseFloat(entry.stabilisationLatestTo);
    },
    validateToWithLatestEntry(entry) {
      if (this.readOnly) return true;
      if (!entry.to || !entry.stabilisationLatestTo) return true;
      return entry.stabilisationLatestTo &&
        parseFloat(entry.stabilisationLatestTo) !== 0 &&
        parseFloat(entry.to) >= parseFloat(entry.stabilisationLatestTo);
    },
    openSideView(holePopupSelectedShift, updateSelectedEntry) {
      this.holePopupSelectedShift = holePopupSelectedShift;
      if (updateSelectedEntry) {
        this.newHole = {
          holeId: -1, // This is to signal the holeInserted method that it should update the selected entry
          code: this.selectedEntry.holeNumber
        }
      }
      else {
        this.newHole = {}; // Reset the sideview model
      }
      this.activeSideView = true;
    },

    closeSideView() {
      this.activeSideView = false;
    },

    // This is not used but somehow Vue 2 doesn't like it when it's removed
    // (either in the component's props or here)
    holeUpdated() {
    },

    holeInserted(hole) {
      // The -1 as the holeId is just to signal this method that it should update the selected entry
      // instead of creating a new one and appending it to the entries list
      const updateSelectedEntry = hole.holeId === -1;
      if (updateSelectedEntry) hole.holeId = 0;

      hole.projectId = this.projectId;
      this.$vs.loading();
      this.$store.dispatch("drilling/addHole", hole).then(() => {
        this.$notifySaveSuccess();
        this.closeSideView();

        if (updateSelectedEntry) {
          this.selectedEntry.holeId = hole.holeId;
          this.selectedEntry.holeNumber = hole.code;
          this.selectedEntry.shift = this.holePopupSelectedShift;
          return this.submitHole(this.selectedEntry, hole);
        }
        this.selectedEntry = {
          holeId: hole.holeId,
          holeNumber: hole.code,
          shift: this.holePopupSelectedShift
        }

      }).catch((error) => {
        this.$handleSaveError(error);
      }).finally(() => {
        this.$vs.loading.close();
      });
    }

  }
}
